import { gregorianToEthiopic } from "ethiopian-calendar-finova";
import { LoginAccount } from "types";

export function getEthiopicDateTime({
  datetime = new Date(),
  displayHour = false,
  timeFormat = "12h",
}) {
  const dateObj = new Date(datetime);
  const ethiopic = gregorianToEthiopic(dateObj);
  // const ethiopic = gregorianToEthiopic(dateObj, timeFormat);
  const hourStr =
    displayHour && ethiopic.hour !== undefined
      ? ethiopic.hour.toString().padStart(2, "0")
      : "";
  const minuteStr =
    displayHour && ethiopic.minute !== undefined
      ? ethiopic.minute.toString().padStart(2, "0")
      : "";

  const timeSuffix =
    displayHour && timeFormat === "12h" && ethiopic.ampm
      ? ` ${ethiopic.ampm}`
      : "";

  return (
    <>
      {ethiopic.day}/{ethiopic.month}/{ethiopic.year}
      {displayHour ? ` ${hourStr}:${minuteStr}${timeSuffix}` : ""}
    </>
  );
}

export const DateView = (
  date: Date | string | null | undefined,
  showTime = false,
) =>
  date
    ? // ? new Date(date).toLocaleString("en-US", {
      //     year: "numeric",
      //     month: "long",
      //     day: "numeric",
      //     ...(showTime && {
      //       hour: "2-digit",
      //       minute: "2-digit",
      //       hour12: true,
      //     }),
      // })
      getEthiopicDateTime({
        datetime: new Date(date),
        displayHour: showTime,
      })
    : "";

export const errorHandler = (error: {
  response: { data: { detail: any }; status: any; statusText: any };
  request: any;
  message: any;
}): string => {
  // Handle different types of errors
  if (error.response) {
    // Server responded with a status code outside the 2xx range
    return (
      error.response.data?.detail ||
      `Server Error: ${error.response.status} - ${error.response.statusText}`
    );
  } else if (error.request) {
    // Request was made but no response was received
    return "Network Error: No response received from the server.";
  } else {
    // Something else happened while setting up the request
    return `Unexpected Error: ${error.message}`;
  }
};

export const errorHandlerOnForm = (error: {
  response?: {
    data?: Record<string, string[] | string>; // Allow both arrays and strings
    status?: number;
    statusText?: string;
  };
  request?: any;
  message?: string;
}): string => {
  if (error.response && error.response.data) {
    const fieldErrors = error.response.data;

    // Map over the field errors and handle both arrays and strings
    const messages = Object.entries(fieldErrors)
      .map(([field, errors]) => {
        if (Array.isArray(errors)) {
          return `${field}: ${errors.join(", ")}`; // Join array of errors
        } else if (typeof errors === "string") {
          return `${field}: ${errors}`; // Handle string errors
        } else {
          return `${field}: Unknown error format`; // Handle unexpected formats
        }
      })
      .join("\n");

    return messages || "An error occurred while submitting the form.";
  } else if (error.request) {
    return "Network Error: No response received from the server.";
  } else {
    return `Unexpected Error: ${error.message}`;
  }
};

export const hasRole = (
  loginRoles: string[] | undefined,
  roleToCheck: string[] | undefined,
  loginData?: LoginAccount | null,
): boolean => {
  if (!roleToCheck || roleToCheck.length === 0) {
    return false;
  }

  if (!loginRoles || loginRoles.length === 0) {
    return false;
  }
  return roleToCheck.some((role) => loginRoles.includes(role));
};

export function splitCamelCase(str: string): string {
  return str.replace(/([a-z])([A-Z])/g, "$1 $2");
}

export function getFileType(filePath: string): string {
  const ext = filePath.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "pdf":
      return "PDF";
    case "doc":
    case "docx":
      return "Word";
    case "xls":
    case "xlsx":
      return "Excel";
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
      return "Image";
    default:
      return ext ? ext.toUpperCase() + " File" : "Unknown";
  }
}

export const formatPhoneNumber = (value: string) => {
  // Remove all non-digits
  const phone = value.replace(/\D/g, "");

  // US formatting
  if (phone.length <= 3) return phone;
  if (phone.length <= 6) return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
  return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
};
